import React from 'react';
import PropTypes from 'prop-types';

import local from './formElementStyles/checkBox.module.css';
import common from './formElementStyles/commonFormElements.module.css';

const CheckBox = ({
    id = '',
    label = '',
    checked = false,
    onChange,
    disabled = false,
    customClass = ''
}) => {
    return (
        <div
            data-testid={`checkbox_${id}`}
            className={`${customClass ? `${local[customClass]}` : ''}`}>
            {label && (
                <label htmlFor={id} className={`${common.formLabel}`}>
                    {label}
                </label>
            )}
            <div className={`${local.checkbox}`}>
                <input
                    id={`checkbox-${id}`}
                    data-testid={`checkbox_input_${id}`}
                    type="checkbox"
                    disabled={disabled}
                    checked={checked}
                    onChange={onChange}
                />
            </div>
        </div>
    );
};

CheckBox.propTypes = {
    id: PropTypes.string,
    label: PropTypes.string,
    checked: PropTypes.bool,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    customClass: PropTypes.string
};

export default CheckBox;
